import $ from 'jquery';

// Vite ESM 전환 후에도 기존 Blade inline script 와 DataTables 는 전역
// window.$ / window.jQuery 존재를 전제로 실행된다. Bootstrap 5 runtime 은
// jQuery 에 의존하지 않으므로 이 파일은 jQuery 전역 노출만 담당한다.
window.$ = window.jQuery = $;
globalThis.$ = globalThis.jQuery = $;

export default $;
